import { useState, useEffect } from "react";
import "../styles.css";
import logoImage from "../assets/logo.png";
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const [smallNav, setSmallNav] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSmallNav(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${smallNav ? "small" : ""}`}>
      <img src={logoImage} alt="Odontologia Guion" className="logo" />
      

      
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><a href="#about">Sobre</a></li>
        <li><a href="#services">Serviços</a></li>
        <li><a href="#team">Equipe</a></li>
        <li><a href="#historia">Quem somos</a></li>
        <li><a href="#espaco">Espaço</a></li>
        <li><a href="#local">Localização</a></li>        
      </ul>
    </nav>
  );
}